import React, {Fragment} from 'react';

import {Drawer} from 'presentation/components/Drawer';
import {translations} from 'presentation/translations-new';

import {Divider} from '@mui/material';
import {
	HealthAddressSection,
	HealthHeaderSection,
	HealthInformationSection,
	HealthPhonesSection,
	HealthProviderDataSection,
	HealthServicesSection,
} from './components';
import {AppointmentsHours} from './components/AppointmentsHours';
import {useHealthGuideDetails} from './hooks/useHealthGuideDetails';
import {HealthGuideDetailsProps} from './types';
import {PendingDialog} from 'presentation/modules/booking/shared/ui/components/PendingDialog';
import {SimpleConfirmationDrawer} from 'presentation/pages/private/booking/components/ConfirmationDrawer/SimpleConfirmationDrawer';

const {close, loading} = translations['pt-br'].commons;
const {guideDetails} = translations['pt-br'].privateFlow.guideFlow;
const {newAppointment} = translations['pt-br'].privateFlow.myAppointments;

export function HealthGuideDetails({
	open,
	handleClose,
	provider,
	showTradeName,
}: HealthGuideDetailsProps) {
	const {
		handleSelectAppointment,
		shouldShowAppointmentButton,
		isMobile,
		isPending,
		handleOpenConfirmationDrawer,
		handleCloseConfirmationDrawer,
		openConfirmationDrawer,
		handleNavigateToBookingFlow,
	} = useHealthGuideDetails(provider, handleClose);

	return (
		<Fragment>
			<Drawer.Root
				open={open}
				onOpen={() => null}
				customMaxHeight={'85%'}
				onClose={handleClose}
				width="420px">
				<Drawer.Header title={guideDetails.headerTitle} onClose={handleClose} />

				{provider ? (
					<Drawer.Content sx={{gap: 2, pb: 3}}>
						<HealthHeaderSection provider={provider} showTradeName={showTradeName} />
						<HealthProviderDataSection provider={provider} />
						<Divider />
						<HealthPhonesSection provider={provider} />
						<Divider />
						<HealthAddressSection provider={provider} />
						<AppointmentsHours
							hours={provider.horariosAtendimento}
							title={guideDetails.availableHours}
						/>
						<Divider />
						<HealthServicesSection provider={provider} />
						<HealthInformationSection provider={provider} />
					</Drawer.Content>
				) : null}
				<Drawer.Footer
					firstButtonTitle={close}
					firstButtonOnClick={handleClose}
					hideSecondButton={!shouldShowAppointmentButton}
					secondButtonTitle={newAppointment}
					secondButtonOnClick={handleSelectAppointment}
					canStacks={isMobile}
				/>
			</Drawer.Root>
			<PendingDialog open={isPending} text={loading} />
			<SimpleConfirmationDrawer
				handleClose={handleCloseConfirmationDrawer}
				handleOpen={handleOpenConfirmationDrawer}
				isOpened={openConfirmationDrawer}
				handleConfirmAndContinue={handleNavigateToBookingFlow}
			/>
		</Fragment>
	);
}
